"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;
/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * This method only exists to support testing in JIL and can be removed once tests are migrated to WDIO.
 * @returns global scope location
 */
function getLocation() {
  return '' + location;
}